<template>
  <div>
  <b-container>
    
    <form @submit.prevent="submit">
        <b-row class="justify-content-md-center" align-h="center">
          <b-col cols="12" sm="10" md="4">
            <h2>Set Your Password</h2>
              <b-alert :show="success"
                      dismissible
                      variant="success">
                <p>Success! You can now login with your new password.</p>
              </b-alert>
              <b-alert :show="error_msg != null" variant="danger">{{error_msg}}</b-alert>
             
            <b-form-group
              :state="!$v.pass.$invalid && !$v.pass_confirm.$invalid"
              :invalid-feedback="passwordError" >
                <!-- password -->
                <b-input-group>
                    <b-form-input v-model="pass"
                        v-show="!showPassword"
                        :state="!$v.pass.$invalid"
                        type="password"
                        placeholder="Password"
                        description="Enter your new password"
                        autocomplete="off" >
                    </b-form-input>
                      <b-form-input v-model="pass"
                        v-show="showPassword"
                        :state="!$v.pass.$invalid"
                        type="text"
                        placeholder="Password"
                        description="Enter your new password"
                        autocomplete="off" >
                    </b-form-input>
                    <b-input-group-append>
                        <b-btn variant="secondary" @click="toggleShowPassword">
                        <icon v-show="showPassword" scale="1" name="eye-slash"></icon>
                        <icon v-show="!showPassword" scale="1" name="eye"></icon>
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
                <p></p>
                <!-- confirm password -->
                <b-input-group>
                  <b-form-input v-model="pass_confirm"
                    v-show="!showPassword"
                    :state="!$v.pass_confirm.$invalid"
                    type="password"
                    placeholder="Confirm Password"
                    description="Re-enter your new password"
                    autocomplete="off">
                  </b-form-input>
                  <b-form-input v-model="pass_confirm"
                      v-show="showPassword"
                      :state="!$v.pass_confirm.$invalid"
                      type="text"
                      placeholder="Confirm Password"
                      description="Re-enter your new password"
                      autocomplete="off">
                  </b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-button type="submit" variant="primary" :disabled="$v.$invalid" >Set Password <icon scale="1" v-show="loading" name="spinner" spin ></icon></b-button>
              <b-button  @click="send_code">Resend Email <icon scale="1" v-show="code_sending" name="spinner" spin ></icon><icon scale="1" v-show="code_sent" name="check"></icon></b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-container>
  </div>
</template>

<script>
  import api from '../api'
  import { required, email, sameAs } from 'vuelidate/lib/validators'

  // Minimum eight characters, at least one letter, one number and one special character
  let pass_regex = value => { return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/.test(value) }

  export default {
    props: ['email_prop', 'reset_token_prop'],
    data () {
      return {
        email: this.email_prop || '',
        reset_token:  this.reset_token_prop || '',
        pass: '',
        pass_confirm: '',
        success: false,
        error_msg: null,
        code_sending: false,
        code_sent: false,
        loading: false,
        showPassword: false
      }
    },
    computed: {
      passwordError() {
        if(!this.$v.pass.required) {
          return 'Password is required'
        } else if (!this.$v.pass_confirm.sameAsPassword) {
          return 'Passwords must match'
        } else if (!this.$v.pass.pass_regex) {
          return 'Password must contain a at least eight characters including at least one letter, one number and one special character ($@$!%*#?&)'
        }
      }
    },
    validations: {
        pass: {
          required,
          pass_regex
        },
        pass_confirm: {
          required,
          sameAsPassword: sameAs('pass')
        }
    },
    methods: {
      toggleShowPassword() {
        this.showPassword = !this.showPassword
      },
      send_code() {
        this.code_sending = true
        this.code_sent = false
        if(this.email.indexOf('@') < 0){
          this.error_msg = 'Email Required'
          return
        }
        var that = this
        api.resetPassword(this.email).then(response => {
          that.code_sending = false
          that.code_sent = true
        })
      },
      submit () {
        this.error_msg = null
        this.loading = true
        var that = this
        api.setPassword(this.email, this.pass, this.reset_token)
          .then(response => {
            that.loading = false
            that.success = true
            setTimeout(() => { that.$router.replace('/login') },3000)
          }).catch(error => {
            if(error.response.data == undefined) {
              that.error_msg = "An unknown error occurred"
            }
            that.error_msg = error.response.data.ret_msg || "An unknown error occurred"
            that.loading = false
          })
      }
    }
  }
</script>

<style scoped>
  .error {
    color: red;
    font-size: 0.8em;
  }
</style>


// WEBPACK FOOTER //
// src/components/SetPassword.vue